import { scrollToElement } from '@/utils/scroll';
import { useRef } from 'react';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

export const useSmoothScroll = () => {
  const isMobile = useScreenSizeContext().isMobile;
  const previousElementId = useRef(null);

  return (ref: HTMLDivElement, shippingId: string, selectedElementId: string): void => {
    const shouldScroll = previousElementId.current !== selectedElementId;
    if (selectedElementId === shippingId && isMobile && shouldScroll) {
      scrollToElement(ref, {
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
      previousElementId.current = selectedElementId;
    }
  };
};
